import { render, staticRenderFns } from "./langs.vue?vue&type=template&id=9b685110"
import script from "./langs.vue?vue&type=script&lang=js"
export * from "./langs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports